var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.66659H1.33334M14.6667 7.33325V5.46659C14.6667 4.71985 14.6667 4.34648 14.5214 4.06127C14.3935 3.81038 14.1895 3.60641 13.9387 3.47858C13.6534 3.33325 13.2801 3.33325 12.5333 3.33325H3.46668C2.71994 3.33325 2.34657 3.33325 2.06136 3.47858C1.81047 3.60641 1.6065 3.81038 1.47867 4.06126C1.33334 4.34648 1.33334 4.71985 1.33334 5.46659V10.5333C1.33334 11.28 1.33334 11.6534 1.47867 11.9386C1.6065 12.1895 1.81047 12.3934 2.06136 12.5213C2.34657 12.6666 2.71994 12.6666 3.46668 12.6666H7.66668M12 13.9999C12 13.9999 14 13.0466 14 11.6167V9.94851L12.5416 9.42739C12.1912 9.30187 11.808 9.30187 11.4576 9.42739L10 9.94851V11.6167C10 13.0466 12 13.9999 12 13.9999Z",
    stroke: "#99C9ED",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.81aa7ebac282776549ad1749049ad1be.svg";
export { ForwardRef as ReactComponent };